<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Update Authentication Configuration</h4>
  <i class="bi bi-x-lg text-danger" style="font-size:larger" (click)="onClose()"></i>
</div>

<div class="text-grey">
  <form [formGroup]="authTypeDetails">
    <mat-form-field appearance="fill" style="width: 90%; margin-left: 4%; margin-top: 2%">
      <mat-label>Default Authentication Type</mat-label>
      <mat-select formControlName="authType" (selectionChange)="optionClicked($event.value)">
        <mat-option value="0" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo"> SyncHPC </mat-option>
        <mat-option value="1" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree"> Local AD </mat-option>
        <mat-option value="2" data-bs-toggle="collapse" data-bs-target="#collapseFour"> Azure AD </mat-option>
        <mat-option value="3" data-bs-toggle="collapse" data-bs-target="#collapseFive"> Okta </mat-option>
        <mat-option value="4" data-bs-toggle="collapse" data-bs-target="#collapseSix"> OpenId </mat-option>
        <mat-option value="5" data-bs-toggle="collapse" data-bs-target="#samlCollapse">
          Saml
        </mat-option>
        <mat-option value="6" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapsePing">
          Ping Identity
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>

<div class="accordion tableWrap text-grey" id="accordionExample">
  <div class="accordion-item">
    <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
        Indentity Server Configuration
      </button>
    </h2>
    <div #panel id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo" data-bs-parent="#accordionExample">
      <div class="accordion-body">
        <form [formGroup]="syncHpcAPIAuthDetails">
          <mat-form-field style="width: 97%; margin:2%">
            <mat-label>Identity Server</mat-label>
            <input matInput
                   title="Identity Server"
                   formControlName="identityServer"
                   placeholder="Enter a identity server" />
            <mat-error *ngIf="
              (syncHpcAPIAuthDetails.get('identityServer').touched &&
              syncHpcAPIAuthDetails.get('identityServer').errors?.required)
              ">
              Identity server is required
            </mat-error>
          </mat-form-field>
          <mat-form-field style="width: 97%; margin:2%">
            <mat-label>Identity Server Port</mat-label>
            <input matInput
                   title="Identity server port"
                   formControlName="identityServerPort"
                   placeholder="Enter Identity Server Port" />
            <mat-error *ngIf="
              (syncHpcAPIAuthDetails.get('identityServerPort').touched &&
              syncHpcAPIAuthDetails.get('identityServerPort').errors?.required) || syncHpcAPIAuthDetails.get('identityServerPort').errors?.pattern
              ">
              Identity server Is Required.
            </mat-error>
          </mat-form-field>
        </form>
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="panelsStayOpen-headingThree">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
        LDAP Configuration
      </button>
    </h2>
    <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingThree" data-bs-parent="#accordionExample">
      <div class="accordion-body">
        <form [formGroup]="ldapAuthDetails">
          <mat-form-field style="width: 97%; margin:2%">
            <mat-label>Enterprise AD Server</mat-label>
            <input matInput
                   title="Enterprise AD Server"
                   formControlName="enterpriseADServer"
                   placeholder="Enter a enterprise AD server" />
            <mat-error *ngIf="
              (ldapAuthDetails.get('enterpriseADServer').touched &&
              ldapAuthDetails.get('enterpriseADServer').errors?.required)
              ">
              Enterprise AD server is required.
            </mat-error>
          </mat-form-field>
          <mat-form-field style="width: 97%; margin: 2%">
            <mat-label>Enterprise Domain Name</mat-label>
            <input matInput
                   title="Enterprise Domain Name"
                   formControlName="enterpriseDomainName"
                   placeholder="Enterprise Domain Name" />
            <mat-error *ngIf="
              (ldapAuthDetails.get('enterpriseDomainName').touched &&
              ldapAuthDetails.get('enterpriseDomainName').errors?.required) || ldapAuthDetails.get('enterpriseDomainName').errors?.pattern
              ">
              Enterprise Domain Name Is Required.
            </mat-error>
          </mat-form-field>
        </form>
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingFour">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
        AzureAD Configuration
      </button>
    </h2>
    <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
      <div class="accordion-body">
        <div class="accordion-body">
          <form [formGroup]="azureADAuthDetails">
            <mat-form-field style="width: 97%; margin: 2%">
              <mat-label>Client ID</mat-label>
              <input matInput
                     title="Client ID"
                     formControlName="clientID"
                     placeholder="Enter a client ID" />
              <mat-error *ngIf="
              (azureADAuthDetails.get('clientID').touched &&
              azureADAuthDetails.get('clientID').errors?.required)
              ">
                Client ID is required
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 97%; margin: 2%">
              <mat-label>Authority</mat-label>
              <input matInput
                     title="Authority"
                     formControlName="authority"
                     placeholder="Enter authority" />
              <mat-error *ngIf="
              (azureADAuthDetails.get('authority').touched &&
              azureADAuthDetails.get('authority').errors?.required) || azureADAuthDetails.get('authority').errors?.pattern
              ">
                Authority Is Required.
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 97%; margin: 2%">
              <mat-label>Redirect Uri</mat-label>
              <input matInput
                     title="Redirect Uri"
                     formControlName="redirectUri"
                     placeholder="Enter redirect URI" />
              <mat-error *ngIf="
              (azureADAuthDetails.get('redirectUri').touched &&
              azureADAuthDetails.get('redirectUri').errors?.required) || azureADAuthDetails.get('redirectUri').errors?.pattern
              ">
                Redirect Uri Is Required.
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 97%; margin: 2%">
              <mat-label>Cache Location</mat-label>
              <input matInput
                     title="Cache Location"
                     formControlName="cacheLocation"
                     placeholder="Enter cache location" />
              <mat-error *ngIf="
              (azureADAuthDetails.get('cacheLocation').touched &&
              azureADAuthDetails.get('cacheLocation').errors?.required) || azureADAuthDetails.get('cacheLocation').errors?.pattern
              ">
                Cache Location Is Required.
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill" style="width: 97%; margin: 2%">
              <mat-label>Store Auth State In Cookie</mat-label>
              <mat-select formControlName="storeAuthStateInCookie">
                <mat-option value="true">Enabled</mat-option>
                <mat-option value="false">Disabled</mat-option>
              </mat-select>
              <mat-error *ngIf="
azureADAuthDetails.get('storeAuthStateInCookie').touched &&
azureADAuthDetails.get('storeAuthStateInCookie').errors?.required
">
                Select Store Auth State In Cookie Flag
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 97%; margin: 2%">
              <mat-label>Protected Resource Map</mat-label>
              <input matInput
                     title="Protected Resource Map"
                     formControlName="protectedResourceMap"
                     placeholder="Enter protected resource map" />
              <mat-error *ngIf="
              (azureADAuthDetails.get('protectedResourceMap').touched &&
              azureADAuthDetails.get('protectedResourceMap').errors?.required) || azureADAuthDetails.get('protectedResourceMap').errors?.pattern
              ">
                Protected Resource Map Is Required.
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 97%; margin: 2%">
              <mat-label>AzureAD Metadata Endpoint</mat-label>
              <input matInput
                     title="AzureAD Metadata Endpoint"
                     formControlName="azureADMetadataEndpoint"
                     placeholder="Enter AzureAD Metadata Endpoint" />
              <mat-error *ngIf="
              (azureADAuthDetails.get('azureADMetadataEndpoint').touched &&
              azureADAuthDetails.get('azureADMetadataEndpoint').errors?.required) || azureADAuthDetails.get('azureADMetadataEndpoint').errors?.pattern
              ">
                AzureAD Metadata Endpoint Is Required.
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 97%; margin: 2%">
              <mat-label>AzureAD Client Secret</mat-label>
              <input matInput
                     title="AzureAD Client Secret"
                     formControlName="azureADClientSecret"
                     placeholder="Enter AzureAD Client Secret" />
              <mat-error *ngIf="
              (azureADAuthDetails.get('azureADClientSecret').touched &&
              azureADAuthDetails.get('azureADClientSecret').errors?.required) || azureADAuthDetails.get('azureADClientSecret').errors?.pattern
              ">
                AzureAD Client Secret Is Required.
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 97%; margin: 2%">
              <mat-label>AzureAD Tenant ID</mat-label>
              <input matInput
                     title="AzureAD Tenant ID"
                     formControlName="azureADTenantID"
                     placeholder="Enter AzureAD Tenant ID" />
              <mat-error *ngIf="
              (azureADAuthDetails.get('azureADTenantID').touched &&
              azureADAuthDetails.get('azureADTenantID').errors?.required) || azureADAuthDetails.get('azureADTenantID').errors?.pattern
              ">
                AzureAD Tenant ID Is Required.
              </mat-error>
            </mat-form-field>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingFive">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
        Okta Configuration
      </button>
    </h2>
    <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
      <div class="accordion-body">
        <div class="accordion-body">
          <form [formGroup]="oktaAuthDetails">
            <mat-form-field style="width: 97%; margin: 2%">
              <mat-label>Issuer</mat-label>
              <input matInput
                     title="Issuer"
                     formControlName="issuer"
                     placeholder="Enter Issuer" />
              <mat-error *ngIf="
              oktaAuthDetails.get('issuer').errors?.required
              ">
                Issuer is required
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 97%; margin:2%">
              <mat-label>Client Id</mat-label>
              <input matInput
                     title="Client Id"
                     formControlName="clientId"
                     placeholder="Client Id" />
              <mat-error *ngIf="
              (oktaAuthDetails.get('clientId').touched &&
              oktaAuthDetails.get('clientId').errors?.required) || oktaAuthDetails.get('clientId').errors?.pattern
              ">
                Client Id Is Required.
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 97%; margin: 2%">
              <mat-label>Redirect Uri</mat-label>
              <input matInput
                     title="Redirect Uri"
                     formControlName="redirectUri"
                     placeholder="Enter a Redirect Uri" />
              <mat-error *ngIf="
              (oktaAuthDetails.get('redirectUri').touched &&
              oktaAuthDetails.get('redirectUri').errors?.required)
              ">
                Redirect Uri is required
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 97%; margin: 2%">
              <mat-label>Scopes</mat-label>
              <input matInput
                     title="Scopes"
                     formControlName="scopes"
                     placeholder="Enter Scopes" />
              <mat-error *ngIf="
              (oktaAuthDetails.get('scopes').touched &&
              oktaAuthDetails.get('scopes').errors?.required)
              ">
                Scopes is required
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 97%; margin: 2%">
              <mat-label>OKTA Metadata Endpoint</mat-label>
              <input matInput
                     title="OKTA Metadata Endpoint"
                     formControlName="oktaMetadataEndpoint"
                     placeholder="Enter a Redirect Uri" />
              <mat-error *ngIf="
              (oktaAuthDetails.get('oktaMetadataEndpoint').touched &&
              oktaAuthDetails.get('oktaMetadataEndpoint').errors?.required)
              ">
                OKTA Metadata Endpoint
              </mat-error>
            </mat-form-field>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingSix">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
        OpenId Configuration
      </button>
    </h2>
    <div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionExample">
      <div class="accordion-body">
        <div class="accordion-body">
          <form [formGroup]="openIdAuthDetails">
            <mat-form-field style="width: 97%; margin: 2%">
              <mat-label>Domain</mat-label>
              <input matInput
                     title="Domain which can be found at Application -> Secret -> Domain"
                     formControlName="domain"
                     placeholder="Enter Domain" />
              <mat-error *ngIf="
              openIdAuthDetails.get('domain').errors?.required
              ">
                Domain is required
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 97%; margin:2%">
              <mat-label>Client Id</mat-label>
              <input matInput
                     title="Client Id which can be found at Application -> Secret -> Client Id"
                     formControlName="clientId"
                     placeholder="Client Id" />
              <mat-error *ngIf="
              (openIdAuthDetails.get('clientId').touched &&
              openIdAuthDetails.get('clientId').errors?.required) || openIdAuthDetails.get('clientId').errors?.pattern
              ">
                Client Id Is Required.
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 97%; margin: 2%">
              <mat-label>Audience</mat-label>
              <input matInput
                     title="Enter audience for the application"
                     formControlName="audience"
                     placeholder="https://{your_domain}/api/v2/" />
              <mat-error *ngIf="
              (openIdAuthDetails.get('audience').touched &&
              openIdAuthDetails.get('audience').errors?.required)
              ">
                Redirect Uri is required
              </mat-error>
            </mat-form-field>
            <mat-form-field style="width: 97%; margin: 2%">
              <mat-label>Client Secret</mat-label>
              <input matInput
                     title="Client Secret which can be found at Application -> Secret -> Client Secret"
                     formControlName="clientSecret"
                     placeholder="Client Secret" />
              <mat-error *ngIf="
              (openIdAuthDetails.get('clientSecret').touched &&
              openIdAuthDetails.get('clientSecret').errors?.required)
              ">
                OKTA Metadata Endpoint
              </mat-error>
            </mat-form-field>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-------- SAML --------->
  <div class="accordion-item">
    <h2 class="accordion-header" id="saml">
      <button class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#samlCollapse"
              aria-expanded="false"
              aria-controls="saml">
        SAML Configuration
      </button>
    </h2>
    <div id="samlCollapse"
         class="accordion-collapse collapse"
         aria-labelledby="samlCollapse"
         data-bs-parent="#accordionExample">
      <div class="accordion-body">
        <form [formGroup]="samlAuthDetails">
          <mat-form-field style="width: 97%; margin: 2%">
            <mat-label>Meta Data URL</mat-label>
            <input matInput
                   title="Enterprise AD Server"
                   formControlName="idPMetadataURL"
                   placeholder="Enter a Metadata URL" />
            <mat-error *ngIf="
                samlAuthDetails.get('idPMetadataURL').touched &&
                samlAuthDetails.get('idPMetadataURL').errors?.required
              ">
              Metadata URL is required.
            </mat-error>
          </mat-form-field>
          <mat-form-field style="width: 97%; margin: 2%">
            <mat-label>Issuer</mat-label>
            <input matInput
                   title="Enterprise Domain Name"
                   formControlName="issuer"
                   placeholder="issuer" />
            <mat-error *ngIf="
                (samlAuthDetails.get('issuer').touched &&
                  samlAuthDetails.get('issuer').errors?.required) ||
                samlAuthDetails.get('issuer').errors?.pattern
              ">
              Issuer Name Is Required.
            </mat-error>
          </mat-form-field>
        </form>
      </div>
    </div>
  </div>

  <!-------- Ping --------->
  <div class="accordion-item">
    <h2 class="accordion-header" id="panelsStayOpen-headingPing">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapsePing" aria-expanded="false" aria-controls="panelsStayOpen-collapsePing">
        Ping Identity Configuration
      </button>
    </h2>
    <div #panel id="panelsStayOpen-collapsePing" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingPing" data-bs-parent="#accordionExample">
      <div class="accordion-body">
        <form [formGroup]="pingAuthDetails">
          <mat-form-field style="width: 97%; margin:2%">
            <mat-label>Public Client ID</mat-label>
            <input matInput formControlName="publicClientId" placeholder="Enter Public Client ID" />
          </mat-form-field>

          <mat-form-field style="width: 97%; margin:2%">
            <mat-label>Confidential Client ID</mat-label>
            <input matInput formControlName="confidentialClientId" placeholder="Enter Confidential Client ID" />
          </mat-form-field>

          <mat-form-field style="width: 97%; margin:2%">
            <mat-label>Confidential Client Secret</mat-label>
            <input matInput formControlName="confidentialClientSecret" placeholder="Enter Confidential Client Secret" />
          </mat-form-field>

          <mat-form-field style="width: 97%; margin:2%">
            <mat-label>Issuer</mat-label>
            <input matInput formControlName="issuer" placeholder="Enter Issuer URL" />
          </mat-form-field>

          <mat-form-field style="width: 97%; margin:2%">
            <mat-label>Token Endpoint</mat-label>
            <input matInput formControlName="tokenEndpoint" placeholder="Enter Token Endpoint" />
          </mat-form-field>

          <mat-form-field style="width: 97%; margin:2%">
            <mat-label>Introspection Endpoint</mat-label>
            <input matInput formControlName="introspectionEndpoint" placeholder="Enter Token Introspection Endpoint" />
          </mat-form-field>

          <mat-form-field style="width: 97%; margin:2%">
            <mat-label>Redirect URI</mat-label>
            <input matInput formControlName="redirectUri" placeholder="Enter Redirect URI" />
          </mat-form-field>

          <mat-form-field style="width: 97%; margin:2%">
            <mat-label>Discovery Endpoint</mat-label>
            <input matInput formControlName="discoveryEndpoint" placeholder="Enter Discovery Endpoint" />
          </mat-form-field>

          <mat-form-field style="width: 97%; margin:2%">
            <mat-label>Scope</mat-label>
            <input matInput formControlName="scope" placeholder="e.g. openid profile email" />
          </mat-form-field>

          <mat-form-field style="width: 97%; margin:2%">
            <mat-label>Response Type</mat-label>
            <input matInput formControlName="responseType" placeholder="e.g. code" />
          </mat-form-field>

          <mat-slide-toggle formControlName="showDebugInformation" style="margin: 2%">
            Show Debug Information
          </mat-slide-toggle>

          <mat-slide-toggle formControlName="disablePKCE" style="margin: 2%">
            Disable PKCE
          </mat-slide-toggle>
        </form>
      </div>
    </div>
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-danger"
          (click)="onClose()">
    Close
  </button>
  <button type="button" class="btn btn-primary"
          [disabled]="!syncHpcAPIAuthDetails.valid || !ldapAuthDetails.valid || !azureADAuthDetails.valid || !oktaAuthDetails.valid"
          (click)="onSubmit(syncHpcAPIAuthDetails, ldapAuthDetails, azureADAuthDetails, oktaAuthDetails,
        samlAuthDetails, pingAuthDetails)">
    Submit
  </button>
</div>
